"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var _Icon = _interopRequireDefault(require("../Icon"));

var _constants = require("../Icon/constants");

require("./Infobox.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Use info boxes to explain input fields further if needed. */
function Infobox(_ref) {
  var accent = _ref.accent,
      error = _ref.error,
      children = _ref.children;
  var infoboxClassName = (0, _utils.getClassNames)('Info-box', {
    'info-box_accent': accent
  }, {
    'info-box_error': error
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: infoboxClassName,
    role: "article"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "info-box_icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: error ? _constants.ICON_TYPE_ERROR : _constants.ICON_TYPE_INFOBOX
  })), /*#__PURE__*/_react.default.createElement("div", null, children));
}

Infobox.propTypes = {
  /** Whether the input has accent theme */
  accent: _propTypes.default.bool,

  /** Whether the input has errored status */
  error: _propTypes.default.bool,

  /** @ignore */
  children: _propTypes.default.node
};
Infobox.defaultProps = {
  accent: false,
  error: false,
  children: null
};
var _default = Infobox;
exports.default = _default;